module.exports = __webpack_public_path__ + "img/garden.c91ea6c3.jpg";